export default __webpack_public_path__ + "static/media/joe-gardner-1.781072ca.jpg";